export const idlFactory = ({ IDL }) => {
  const Address = IDL.Record({ chain: IDL.Text, address: IDL.Text })
  const NamedAddress = IDL.Record({
    bio: IDL.Opt(IDL.Text),
    owner: IDL.Principal,
    name: IDL.Text,
    name_updated_at: IDL.Opt(IDL.Nat64),
    addresses: IDL.Vec(Address),
    profile_pic: IDL.Opt(IDL.Text),
  })
  const Result = IDL.Variant({ Ok: NamedAddress, Err: IDL.Text })
  const HttpRequest = IDL.Record({
    url: IDL.Text,
    method: IDL.Text,
    body: IDL.Vec(IDL.Nat8),
    headers: IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
  })
  const HttpResponse = IDL.Record({
    body: IDL.Vec(IDL.Nat8),
    headers: IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
    upgrade: IDL.Opt(IDL.Bool),
    status_code: IDL.Nat16,
  })
  const NamedAddressUpdate = IDL.Record({
    bio: IDL.Opt(IDL.Text),
    name: IDL.Opt(IDL.Text),
    addresses: IDL.Vec(Address),
    profile_pic: IDL.Opt(IDL.Text),
  })
  const Result_1 = IDL.Variant({ Ok: IDL.Null, Err: IDL.Text })
  return IDL.Service({
    autocomplete: IDL.Func([IDL.Text], [IDL.Vec(NamedAddress)], ['query']),
    get_all: IDL.Func([], [IDL.Vec(IDL.Tuple(IDL.Text, NamedAddress))], ['query']),
    get_named_address_by_name: IDL.Func([IDL.Text], [Result], ['query']),
    get_named_address_by_owner: IDL.Func([IDL.Principal], [Result], ['query']),
    http_request: IDL.Func([HttpRequest], [HttpResponse], ['query']),
    register_user: IDL.Func([], [Result], []),
    update_named_address: IDL.Func([NamedAddressUpdate], [Result], []),
    validate_name: IDL.Func([IDL.Text], [Result_1], ['query']),
  })
}
export const init = ({ IDL }) => {
  return []
}
